<!-- <mat-chip-list #chipList> -->
<mat-chip-set #chipList>
  <mat-chip
    *ngFor="let item of formControl.value;let i = index"
    [selectable]="selectable"
    [removable]="removable"
    (removed)="remove(i)">
    {{ item }}
    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
  </mat-chip>
  <input
    [formControl]="itemControl"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="addOnBlur"
    (matChipInputTokenEnd)="add($event)"
    (blur)="onBlur()"/>
</mat-chip-set>
<mat-autocomplete
  #auto="matAutocomplete"
  (optionSelected)="selected($event)">
  <mat-option *ngFor="let item of (filter | async)" [value]="item">
    {{ item }}
  </mat-option>
</mat-autocomplete>
